import { render, staticRenderFns } from "./copeappr.vue?vue&type=template&id=3818e880&scoped=true&"
import script from "./copeappr.vue?vue&type=script&lang=js&"
export * from "./copeappr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3818e880",
  null
  
)

export default component.exports